<template>
    <div id="noData">
        <img src="@/assets/images/template/bg-pic2.png"/>
        <span>{{$t("trade.noData.noData")}}</span>
        <a v-if="isTrade" @click="goPosition">{{$t("trade.noData.goPosition")}}</a>
    </div>
</template>

<script>
    import {mapState} from 'vuex'
    
    export default {
        name: "NoData",
        props:['isTrade'],
        computed: {
            ...mapState(['quote']),
            tickList: {
                get() {
                    let newTickList=[];
                    let codes = process.env.VUE_APP_PRODUCTS.split(",");
                    for(const i in codes){
                        for(const j in this.quote.tickList){
                            if(codes[i] == this.quote.tickList[j].uiCodeID){
                                newTickList.push(this.quote.tickList[j]);
                                break;
                            }
                        }
                   
                    }
                    return newTickList;
                }
            }
        },

        methods:{
            goPosition(){
                this.$router.replace({path:'/home/quoteChart',query: {id: this.tickList[0].uiCodeID}});
            }
        }
    }
</script>
